export const smsKey = 'drive-app-link';
